import * as Sentry from "@sentry/nextjs"
import axios from "axios"

import { ApiResponse } from "@shared/types/api/common"
import {
  MakeThumbnailData,
  MakeThumbnailOut,
  PasswordAndSecretOut,
  UuidGeneratorOut,
} from "@shared/types/api/formatters"

const GeneratorsApi = {
  makeThumbnail: async (makeThumbnailData: MakeThumbnailData) => {
    const formData = new FormData()

    for (const [key, value] of Object.entries(makeThumbnailData)) {
      if (value !== undefined && typeof value == "number") {
        if (!Number.isNaN(value)) formData.append(key, value.toString())
      } else {
        formData.append(key, value[0])
      }
    }

    try {
      const { data } = await axios.post<ApiResponse<MakeThumbnailOut>>(`/api/generators/thumbnail`, formData)
      const result = data.result || null
      return { result }
    } catch (err) {
      Sentry.captureException(err)
      console.log(err)
      return { result: null }
    }
  },

  makePasswordAndSecretHandler: async () => {
    try {
      const { data } = await axios.get<ApiResponse<PasswordAndSecretOut>>(`/api/generators/password-and-secret`)
      const result = data.result
      return { result }
    } catch (err) {
      Sentry.captureException(err)
      console.log(err)
      return { result: null }
    }
  },

  makeUuidGeneratorHandler: async () => {
    try {
      const { data } = await axios.get<ApiResponse<UuidGeneratorOut>>(`/api/generators/uuid`)
      const result = data.result
      return { result }
    } catch (err) {
      Sentry.captureException(err)
      console.log(err)
      return { result: null }
    }
  },
}

export default GeneratorsApi
